class GuideHome {
    constructor(options) {
        const defaultOptions = {
            apiDomain: null
        };

        this.options = Object.assign({}, defaultOptions, options);
        this.scrollMargin = 60;

        this.init();
    }

    init() {
        window.addEventListener("DOMContentLoaded", this.checkingDevices.bind(this));
        window.addEventListener("scroll", this.shortcutScroll.bind(this));
        window.addEventListener("resize", this.checkingDevices.bind(this));

        this.classicGuideHomeScroll();
        this.claasicGuideHomeAddClass();
        this.setSlickClassic();
        this.setSlickClassic(true, true); // 탭메뉴 안에 slick
        this.shortcutController();
    }

    // 모바일 slick
    setSlickClassic(isTabsets, isCurrent) {
        let target;
        if (!isTabsets) {
            target = $('.classic-guide-content .classic-guide-content-slick');
        } else {
            target = $('.classic-guide-content .classic-guide-content-tabsets-slick');
        }

        $(target).each(function (index, item) {
            $(item).slick({
                dots: true,
                infinite: false,
                arrows: false,
                speed: 300,
                slidesToScroll: 1,
                observer: true,
                observeParents: true,
                adaptiveHeight: true,
                mobileFirst: true,
                responsive: [{
                        breakpoint: 960,
                        settings: "unslick"
                    },
                    {
                        breakpoint: 640,
                        slidesToShow: 1
                    }
                ]
            });
        });

        $(window).resize(function () {
            if (!isCurrent) {
                $('.classic-guide-content .classic-guide-content-slick').slick('resize');
            } else {
                $('.classic-guide-content .is-current-panel .classic-guide-content-tabsets-slick').slick('resize');
            }
        });
    }

    // 숏컷 메뉴 클릭시 스크롤
    classicGuideHomeScroll() {
        const claasicGuideContent = document.querySelectorAll('.classic-guide-contents .classic-guide-content');
        const scBtn = document.querySelectorAll('.classic-guide-shortcut-btns .wrap-sc-btn .sc-btn');

        for (let i = 0; i < claasicGuideContent.length; i++) {
            scBtn[i].addEventListener('click', function (event) {
                event.preventDefault();                  
                claasicGuideContent[i].scrollIntoView ({
                    behavior: "smooth",
                })                
            });
        }
    }

    // 탭 클릭 시 클래스 추가
    claasicGuideHomeAddClass() {
        const claasicGuideTabset = document.querySelectorAll('.classic-guide-tabsets .classic-guide-tabset');
        const claasicGuideTabpanel = document.querySelectorAll('.classic-guide-tab-panels .classic-guide-tab-panel');

        for (let i = 0; i < claasicGuideTabset.length; i++) {
            claasicGuideTabset[i].addEventListener('click', function () {
                (document.querySelector('.is-current-panel')) ? document.querySelector('.is-current-panel').classList.remove('is-current-panel') : '';
                claasicGuideTabpanel[i].classList.add('is-current-panel');
                $('.classic-guide-content .is-current-panel .classic-guide-content-tabsets-slick').slick('setPosition');
                $('.classic-guide-content .is-current-panel .classic-guide-content-tabsets-slick').slick('resize');
            });
        }
    }

    // 숏컷 토글
    shortcutController() {
        const shortcutBtns = document.querySelector('.classic-guide-shortcut-btns');
        const shortcutBtnController = document.querySelector('.classic-guide-shortcut-btns .controller-sc-btn');
        shortcutBtnController.addEventListener('click', function () {
            shortcutBtns.classList.toggle('is-show-toggle')
        });
    }

    // 디바이스 체크
    checkingDevices() {
        let windowWidth = document.body.clientWidth;
        if (windowWidth <= 960) {
            this.scrollMargin = 107;
        } else {
            this.scrollMargin = 60;
        }
    }

    // 숏컷 스크롤 적용
    shortcutScroll() {
        const classicGuideContent = document.querySelectorAll(".classic-guide-content");
        const SCROLL_STANDARD_NUMBER = 70;
        let scrollY = window.pageYOffset;
        let scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
        

        classicGuideContent.forEach(current => {
            const contentsHeight = current.offsetHeight;
            const contentsTop = current.offsetTop - this.scrollMargin;
            let classicGuideContentsId = current.getAttribute('id');

            if (
                scrollY > contentsTop &&
                scrollY <= contentsTop + contentsHeight
            ) {
                document.querySelector(".wrap-sc-btn a[href*=" + classicGuideContentsId + "]").classList.add("is-scroll-active");
            } else {
                document.querySelector(".wrap-sc-btn a[href*=" + classicGuideContentsId + "]").classList.remove("is-scroll-active");
            }            
            
            if (scrollBottom <= SCROLL_STANDARD_NUMBER) {                
                document.querySelector('.is-scroll-active') ? document.querySelector('.is-scroll-active').classList.remove('is-scroll-active') : '';
                document.querySelector(".wrap-sc-btn a[href='#guide-4']").classList.add("is-scroll-active");                   
            }           

        });
    }
}

export default GuideHome;